export default __webpack_public_path__ + "static/media/homeIcon.7f31f2ac.png";